// aria-labely mobilní hlavičky (mobileHeader.js).
export default {
  menu: 'Menu',
  search: 'Hledat',
  close: 'Zavřít',
};
